import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getAllOrganisationsApi } from '../../../services/api';
import { updateState } from '../../../redux/commonSlice';
import { showSnackBar } from '../../../utils/commonServices';

export const useOrganisationsList = () => {
  const dispatch = useDispatch();

  return useQuery(
    'organisations',
    async () => {
      const response = await getAllOrganisationsApi();
      if (response?.data?.http_code === 200) {
        const orgDetails = response.data?.data?.org_details ?? [];
        dispatch(updateState({ organisation_list: orgDetails }));
        return orgDetails;
      }
      throw new Error(response?.data?.message || 'Failed to fetch organisations');
    },
    {
      staleTime: 0,
      onError: (error) => {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
      },
    }
  );
};
